module.exports = __webpack_public_path__ + "img/oneYear.e0075294.png";